import React from 'react';

// Renders a string containing literal `<em>...</em>` markup as safe React JSX,
// applying the brand's italic-accent class to emphasised spans.
// Avoids dangerouslySetInnerHTML for content that mixes plain text + emphasis.
//
// Usage:
//   <h1>{renderEmphasis('You need a wardrobe <em>strategy.</em>')}</h1>
export default function renderEmphasis(input) {
  if (typeof input !== 'string' || !input.includes('<em>')) return input;
  const parts = input.split(/<em>(.*?)<\/em>/g);
  return parts.map((chunk, i) =>
    i % 2 === 1
      ? <em key={i} className="italic-accent">{chunk}</em>
      : <React.Fragment key={i}>{chunk}</React.Fragment>
  );
}
